const UP_TREND_COLOR = "#E61B1B";
const DOWN_TREND_COLOR = "#118861";

const WIDGET_4_DASHBOARD_1_COLORS = [
  "rgb(168, 191, 36)",
  "rgb(81, 140, 195)",
  "rgb(215, 69, 84)",
];

const WIDGET_6_DASHBOARD_1_LEGEND_COLORS = ["#fde0dd", "#fa9fb5", "#c51b8a"];

// const WIDGET_6_DASHBOARD_1_COLORS = [
//   "rgb(168, 191, 36)",
//   "rgb(81, 140, 195)",
//   "rgb(215, 69, 84)",
// ];

export {
  UP_TREND_COLOR,
  DOWN_TREND_COLOR,
  WIDGET_4_DASHBOARD_1_COLORS,
  WIDGET_6_DASHBOARD_1_LEGEND_COLORS,
  // WIDGET_6_DASHBOARD_1_COLORS,
};
